import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Text } from '@beef/ui-kit';
import { useDispatch } from 'react-redux';
import { setTableFilters } from '../../../../store/expensesData/action';
import { ACCUMULATOR_TREE_LINKS } from '../../../../store/expensesData/constants';

// Styles
import styles from './styles.pcss';
const cx = classNames.bind(styles);

/**
 *
 * name (название аккумулятора),
 * cost (цена),
 * accumulatorUnit (валюта, значение),
 * width (считает наполнение и цвет аккумулятора сейчас),
 * hasArrow = true (определяет кликабельность аккумулятора)
 * rest, size (todo: будет считать наполнение и цвет аккумулятора)
 *
 * todo: 1- вынести функции в юниты, 2 - сделать анимацию наполнения аккумулятора, 3 - прокинуть верные пропсы
 *
 */

const Accumulator = ({
  id,
  name,
  cost,
  accumulatorUnit = '₽',
  width,
  color,
  hasArrow = true,
}) => {
  const progressBarRef = useRef(null);
  const dispatch = useDispatch();

  const handleChangeFilterNumberRoaming = () => {
    const searchInnerIds = (root) => [root.id, ...root.children.reduce((acc, child) => [...acc, ...searchInnerIds(child)], [])];
    const checkIds = new Set(searchInnerIds(ACCUMULATOR_TREE_LINKS[id]));
    const action = (x) => checkIds.has(x?.filterId);
    dispatch(setTableFilters('Accumulators', action));
  };

  return (
    <button
      className={cx('accumulator')}
      onClick={handleChangeFilterNumberRoaming}
      type="button"
    >
      <div
        className={cx('progress-bar', 'color', `progress-bar--${color}`)}
        style={{ width }}
        ref={progressBarRef}
      >
        <span className={cx('progress-bar__span', `progress-bar__span--${color}`)} />
        <div className={cx('content')}>
          <Text size="size6-m">
            {cost}
            {' '}
            {accumulatorUnit}
          </Text>
          {' '}
          <Text size="size6-r" tagType="p" color="grey50">
            {name}
          </Text>
        </div>
      </div>
      {hasArrow && <div className={cx('arrow')} /> }
    </button>
  );
};

Accumulator.propTypes = {
  name: PropTypes.string,
  cost: PropTypes.number,
  accumulatorUnit: PropTypes.string,
  width: PropTypes.number,
  hasArrow: PropTypes.bool,
};

export default Accumulator;
